import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Typography,
} from '@mui/material';
import useDialog from 'hooks/useDialog';
import { RejectedStatus } from '../ApplicationStatusControl';
import { useRecordContext } from 'react-admin';
import { ProfessionalDisplayHelper } from 'utils/displayHelpers/professional';
import { IProfessional } from '@medely/types';

interface RejectItemLegacyProps {
  updateApplicationStatus: (val: any) => void;
}

const PROFESSIONAL_TYPE = {
  AGENCY: 'AGENCY',
  IRP: 'IRP',
  MARKETPLACE: 'MARKETPLACE',
} as const;

const reasonChoices = [
  'Conflict of Interest',
  'Deactivated Account',
  'Duplicate Account',
  'Falsifying Document',
  'No relevant experience',
  'Not a good fit - Bad Attitude',
  'Test Account',
];

const RejectItemLegacy = ({ updateApplicationStatus }: RejectItemLegacyProps) => {
  const { open, closeDialog, openDialog } = useDialog();

  return (
    <>
      <MenuItem onClick={openDialog}>Reject</MenuItem>
      <RejectDialogLegacy
        open={open}
        closeDialog={closeDialog}
        updateApplicationStatus={updateApplicationStatus}
      />
    </>
  );
};

const RejectDialogLegacy = ({ open, closeDialog, updateApplicationStatus }) => {
  const [rejectReason, setRejectReason] = useState('');
  const [phoneInterviewed, setPhoneInterviewed] = useState(false);
  const submitUpdateApplicationStatus = () => {
    updateApplicationStatus({
      application_status: RejectedStatus,
      reject_reason: rejectReason,
      phone_interviewed: phoneInterviewed,
    });
  };
  const record: IProfessional = useRecordContext();

  const getProfessionalTypeString = (proType: string) => {
    const type = proType?.toUpperCase();
    if (type === PROFESSIONAL_TYPE.AGENCY) {
      const agencyName = record?.account.agency?.name;
      return `Agency${agencyName ? ` (${agencyName})` : ''}`;
    }
    if (type === PROFESSIONAL_TYPE.IRP) {
      const companyName = record?.account.company?.name;
      return `IRM${companyName ? ` (${companyName})` : ''}`;
    }
    if (type === PROFESSIONAL_TYPE.MARKETPLACE) {
      return 'Marketplace';
    } else {
      return 'professional';
    }
  };

  const fullName = (professional: IProfessional) => {
    return (
      professional?.account &&
      `${professional.account.first_name} ${professional.account.last_name}`
    );
  };

  const professionalType = record ? new ProfessionalDisplayHelper(record).type : '';
  const professionalName = record ? fullName(record) : '';

  return (
    <Dialog open={open} onClose={closeDialog}>
      <DialogTitle>Reject Reason</DialogTitle>
      <DialogContent>
        <Typography>
          Professional Name:{' '}
          <Typography component="span" color="error" fontWeight="bold">
            {professionalName}
          </Typography>
          <br />
          Professional Type:{' '}
          <Typography component="span" color="error" fontWeight="bold">
            {getProfessionalTypeString(professionalType)}
          </Typography>
        </Typography>
      </DialogContent>
      <DialogContent>
        <Select
          fullWidth
          value={rejectReason}
          label="Select Reject Reason"
          onChange={({ target }) => setRejectReason(target.value as string)}
          required
          style={{ width: '550px', marginBottom: '20px' }}
        >
          {reasonChoices.map((reason) => (
            <MenuItem key={reason} value={reason}>
              {reason}
            </MenuItem>
          ))}
        </Select>
        <FormGroup>
          <FormControlLabel
            label="Performed Verbal Screen"
            control={
              <Checkbox
                checked={phoneInterviewed}
                onChange={(event) => setPhoneInterviewed(event.target.checked)}
              />
            }
          />
        </FormGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeDialog}>Cancel</Button>
        <Button
          disabled={!rejectReason}
          onClick={submitUpdateApplicationStatus}
          color="primary"
          variant="contained"
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RejectItemLegacy;
